var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_2714",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_2714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2753 12.5945C11.1997 12.5945 10.4051 12.372 10.3636 12.3591L9.99364 11.5589C10.8681 10.9222 11.1082 9.93503 11.1739 9.45617C11.7684 9.30171 12.3147 8.63048 12.5335 7.74116C12.6512 7.26057 12.4788 6.8132 12.1043 6.62781C12.0002 6.57597 11.8846 6.54916 11.7674 6.54967C11.7869 6.40983 11.8071 6.23869 11.8281 6.02832C11.8771 5.53778 11.9083 5.04233 11.9083 4.91666C11.9083 4.39144 11.7221 3.59439 11.1997 2.93247C10.3302 1.83113 8.95798 1.59998 7.95992 1.59998C6.97822 1.59998 5.614 1.81562 4.68991 2.8429C3.96237 3.65167 3.80422 4.63927 3.87537 5.10588C3.87797 5.12276 3.89361 5.20227 3.9186 5.32097C3.91994 5.33658 3.92263 5.35206 3.92665 5.36724C3.92732 5.36966 3.92937 5.37695 3.93273 5.38767C3.99671 5.68713 4.10589 6.16905 4.21872 6.56779C4.11661 6.57634 4.01746 6.60514 3.92753 6.65238C3.56804 6.83902 3.40322 7.27668 3.51735 7.74132C3.73651 8.63229 4.28434 9.30408 4.88001 9.45714C4.95016 9.92254 5.1938 10.8875 6.02884 11.5251L5.63417 12.3423C5.35501 12.4261 5.0481 12.5082 4.72316 12.5945C2.72889 13.1242 0 13.8495 0 16.2625V18.0025C0 18.5921 3.51735 20.8 7.81802 20.8C12.1043 20.8 16 18.9697 16 18.0025C16 17.5052 16 16.9667 16 16.2625C16 13.7145 13.4058 13.1721 11.2753 12.5945Z",
    fill: "#333D6C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientAvatar);
export default __webpack_public_path__ + "static/media/patient-avatar.d6cc328e8a3931beeac7090a37e0c12a.svg";
export { ForwardRef as ReactComponent };